module.exports = __webpack_public_path__ + "img/logo-education-in-russia.7a93db6b.png";